import { useState } from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { HeadingXS, ParagraphMD, Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { NameInCreditsCountdown } from './NameInCreditsCountdown'

interface Props {
  newPifLayout?: boolean
}

const CHARACTERS_IMG_URL = '/v1761147736/theatrical/david/saul-jonathan-name-credits-light.png'

export function NameInCreditsSection({ newPifLayout }: Props) {
  const { t } = useTranslate('pif')
  const [didImageFailToLoad, setDidImageFailToLoad] = useState<boolean>(false)

  if (!newPifLayout) return null

  return (
    <section className="px-4 pb-6 md:px-0 md:pb-10">
      <div className={classNames('grid items-start gap-6 md:gap-8', 'md:grid-cols-[404px_1fr]')}>
        {!didImageFailToLoad && (
          <div className="w-full">
            <div className="mx-auto w-full max-w-[404px]">
              <Image
                src={CHARACTERS_IMG_URL}
                alt=""
                width={404}
                height={404}
                className="h-auto w-full object-contain"
                onError={() => setDidImageFailToLoad(true)}
              />
            </div>
          </div>
        )}

        <div className="flex h-full flex-col justify-center gap-6">
          <NameInCreditsCountdown />

          <div className="flex flex-col gap-3">
            <HeadingXS weight="bold" color="core-gray-950">
              {t('nameInCreditsHeading', 'Etch Your Name in the Movie Credits of DAVID')}
            </HeadingXS>
            <ParagraphMD color="core-gray-700">
              {t(
                'nameInCreditsParagraph',
                'Pay it Forward for at least 35 kids ($500) to see DAVID and we’ll thank you by including your name in the movie credits—across the theatrical, streaming, and DVD releases.',
              )}
            </ParagraphMD>
          </div>
          <div className="flex flex-row flex-wrap items-center gap-2">
            <ParagraphMD color="core-gray-950" weight="bold">
              {t('theatricalCutoffDateLabel', 'Theatrical Cutoff Date:')}
            </ParagraphMD>
            <Text color="core-gray-950">{t('theatricalCutoffDateValue', 'November 10, 2025')}</Text>
          </div>
        </div>
      </div>
    </section>
  )
}
